const baseURL = "/v1/AnoLetivo";

const service = {
  methods: {
    $buscarAnosLetivos(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarAnoLetivos({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarAnoLetivo(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarAnoLetivo(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarAnoLetivo(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
